"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _apis = require("../../../../@apis");
var _store = require("../../../../@api/store");
var _appcenter = _interopRequireWildcard(require("../../../../@api/appcenter"));
var _SimpleButton = _interopRequireDefault(require("../../../../@custom/SimpleButton"));
var _TextInput = _interopRequireDefault(require("../../../../@custom/TextInput"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var appcenterStorage = _appcenter.firebase.storage();
var KB = 1024;
var MAX_PHOTO_SIZE = 800 * KB;

/**
 * @typedef User
 * @type {import("../../index").User}
 */

/**
 * @typedef AccountPageProps
 * @type {import("../../index").AccountPageProps}
 */

/** @param {AccountPageProps} props */
function Profile(props) {
  var auth = props.auth;

  /** @type {[User, React.Dispatch<React.SetStateAction<User>>]} */
  var _useState = (0, _react.useState)(_objectSpread({}, auth.user)),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    user = _useState2[0],
    setUser = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    confirmAccountDeletion = _useState4[0],
    setConfirmAccountDeletion = _useState4[1];
  var userName = (0, _react.useMemo)(function () {
    return "".concat(user.firstName, " ").concat(user.lastName).replace(/\s+/g, ' ').trim();
  }, [user.firstName, user.lastName]);
  var companyName = (0, _react.useMemo)(function () {
    return auth.company.fantasyName || auth.company.name;
  }, [auth.company.name, auth.company.fantasyName]);
  var userPhone = (0, _react.useMemo)(function () {
    var part1 = user.phone.slice(0, 5);
    var part2 = user.phone.slice(5);
    return "(".concat(user.phoneArea, ") ").concat(part1, "-").concat(part2);
  }, [user.phone, user.phoneArea]);
  var userAddress = (0, _react.useMemo)(function () {
    return user.addresses[0];
  }, [user.addresses]);

  /** @param {{ [key: string]: any }} updates */
  var updateUser = function updateUser(updates) {
    setUser(function (prev) {
      var updated = _objectSpread({}, prev);
      for (var _i = 0, _Object$entries = Object.entries(updates); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = (0, _slicedToArray2["default"])(_Object$entries[_i], 2),
          path = _Object$entries$_i[0],
          value = _Object$entries$_i[1];
        var _props = path.split('.');
        var obj = updated;
        for (var i = 0; i < _props.length; i++) {
          var prop = _props[i];
          var isLastProp = i === _props.length - 1;
          if (isLastProp) {
            obj[prop] = value;
          } else {
            obj[prop] = (0, _typeof2["default"])(obj[prop]) === 'object' ? obj[prop] : {};
            obj = obj[prop];
          }
        }
      }
      return updated;
    });
  };

  /**
   * @param {string} prop
   * @returns {(evt: React.ChangeEvent<HTMLInputElement>, isCheckbox: boolean=) => void}
   */
  var handleChangeUser = function handleChangeUser(prop) {
    return function (evt) {
      var isCheckbox = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var value = evt.target[isCheckbox ? 'checked' : 'value'];
      updateUser((0, _defineProperty2["default"])({}, prop, value));
    };
  };

  /** @param {React.ChangeEvent<HTMLInputElement>} evt */
  var handleChangeUserPhone = function handleChangeUserPhone(evt) {
    var value = evt.target.value.replace(/\D/g, '');
    var phoneArea = value[0] + value[1];
    var phone = value.slice(2);
    updateUser({
      phoneArea: phoneArea,
      phone: phone
    });
  };

  /**
   * @param {string} prop
   * @returns {(evt: React.ChangeEvent<HTMLInputElement>) => void}
   */
  var handleChangeUserAddress = function handleChangeUserAddress(prop) {
    return function (evt) {
      var value = evt.target.value;
      if (prop === 'postalCode' || prop === 'streetNumber') {
        value = value.replace(/\D/g, '');
      }
      if (prop === 'country' || prop === 'state') {
        value = value.replace(/[^a-zA-Z]/g, '').toUpperCase().slice(0, 2);
      }
      updateUser((0, _defineProperty2["default"])({}, "addresses.0.".concat(prop), value));
    };
  };
  var handleSaveUser = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var _auth$company;
      var _auth$company2;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (auth !== null && auth !== void 0 && auth.isAuthenticated) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            if (auth !== null && auth !== void 0 && (_auth$company = auth.company) !== null && _auth$company !== void 0 && _auth$company.uid) {
              _context.next = 4;
              break;
            }
            return _context.abrupt("return");
          case 4:
            _context.prev = 4;
            _context.next = 7;
            return _apis.appcenterApi.company.users.save((_auth$company2 = auth.company) === null || _auth$company2 === void 0 ? void 0 : _auth$company2.uid, user);
          case 7:
            _store.services.message.show('Alterações salvas!', 'As alterações foram salvas com sucesso!');
            _context.next = 14;
            break;
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](4);
            _store.services.message.show('Erro ao salvar alterações!', 'Não foi possível salvar as alterações!');
            console.log('ERROR handleSaveUser: >=>', _context.t0);
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[4, 10]]);
    }));
    return function handleSaveUser() {
      return _ref.apply(this, arguments);
    };
  }();
  var handleResetUser = function handleResetUser() {
    setUser(auth.user);
  };

  /** @param {HTMLInputElement} inputFile */
  var handleChangeUserPhoto = function handleChangeUserPhoto(inputFile) {
    return /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var allowedFiles, files, file, ref, url;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            allowedFiles = ['image/jpeg', 'image/png'];
            files = inputFile.files;
            if (files) {
              _context2.next = 4;
              break;
            }
            return _context2.abrupt("return");
          case 4:
            file = files[0];
            if (file) {
              _context2.next = 7;
              break;
            }
            return _context2.abrupt("return");
          case 7:
            if (allowedFiles.includes(file.type)) {
              _context2.next = 9;
              break;
            }
            return _context2.abrupt("return", _store.services.message.show('Arquivo inválido!', 'Somente arquivos PNG ou JPEG são permitidos!'));
          case 9:
            ref = appcenterStorage.ref("photos/".concat(user.uid, "/").concat(file.name));
            _context2.next = 12;
            return ref.put(file);
          case 12:
            _context2.next = 14;
            return ref.getDownloadURL();
          case 14:
            url = _context2.sent;
            updateUser({
              photo: url
            });
          case 16:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
  };
  var handleLoadPhoto = function handleLoadPhoto() {
    var inputFile = document.createElement('input');
    inputFile.type = 'file';
    inputFile.accept = 'image/jpeg, image/png';
    inputFile.onchange = handleChangeUserPhoto(inputFile);
    inputFile.click();
  };
  var handleDisableAccount = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
      var _auth$company3;
      var _auth$company4;
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (auth !== null && auth !== void 0 && auth.isAuthenticated) {
              _context3.next = 2;
              break;
            }
            return _context3.abrupt("return");
          case 2:
            if (auth !== null && auth !== void 0 && (_auth$company3 = auth.company) !== null && _auth$company3 !== void 0 && _auth$company3.uid) {
              _context3.next = 4;
              break;
            }
            return _context3.abrupt("return");
          case 4:
            _context3.prev = 4;
            _apis.appcenterApi.company.users.disableUsers((_auth$company4 = auth.company) === null || _auth$company4 === void 0 ? void 0 : _auth$company4.uid, user);
            _context3.next = 8;
            return _appcenter["default"].auth.logout();
          case 8:
            _context3.next = 14;
            break;
          case 10:
            _context3.prev = 10;
            _context3.t0 = _context3["catch"](4);
            _store.services.message.show('Erro ao desativar conta!', 'Não foi possível desativar esta conta!');
            console.log('ERROR handleSaveUser: >=>', _context3.t0);
          case 14:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[4, 10]]);
    }));
    return function handleDisableAccount() {
      return _ref3.apply(this, arguments);
    };
  }();
  var handleResetPhoto = function handleResetPhoto() {
    updateUser({
      photo: auth.user.photo
    });
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "Account-profile",
    "data-fullwidth": true,
    "data-fullheight": true
  }, /*#__PURE__*/_react["default"].createElement("section", {
    className: "Account-profile-section"
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: "Account-title"
  }, "Detalhes do perfil"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "Account-profile-columns",
    "data-fullwidth": true
  }, /*#__PURE__*/_react["default"].createElement(_material.Avatar, {
    className: "Account-profile-photo",
    variant: "rounded",
    src: user.photo || auth.user.photo,
    alt: userName
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "Account-profile-rows",
    "data-align-y": "center",
    "data-fullheight": true
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "Account-profile-columns"
  }, /*#__PURE__*/_react["default"].createElement(_SimpleButton["default"], {
    className: "Account-profile-loadPhoto",
    onClick: handleLoadPhoto
  }, "CARREGAR NOVA FOTO"), /*#__PURE__*/_react["default"].createElement(_SimpleButton["default"], {
    className: "Account-profile-resetPhoto",
    onClick: handleResetPhoto
  }, "RESETAR")), /*#__PURE__*/_react["default"].createElement("p", null, "PNG ou JPEG permitido. Tamanho m\xE1ximo de ", MAX_PHOTO_SIZE / KB, " KB"))), /*#__PURE__*/_react["default"].createElement(_material.Divider, {
    orientation: "horizontal"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "Account-profile-columns",
    "data-fullwidth": true
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "Account-profile-input"
  }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    fullWidth: true,
    label: "Primeiro nome",
    type: "text",
    placeholder: "Jo\xE3o",
    onChange: handleChangeUser('firstName'),
    value: user.firstName
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "Account-profile-input"
  }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    fullWidth: true,
    label: "\xDAltimo nome",
    type: "text",
    placeholder: "P\xE9 de Feij\xE3o",
    onChange: handleChangeUser('lastName'),
    value: user.lastName
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "Account-profile-columns",
    "data-fullwidth": true
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "Account-profile-input"
  }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    fullWidth: true,
    label: "Email",
    type: "text",
    placeholder: "joao-pe-de-feijao@gmail.com",
    onChange: handleChangeUser('email'),
    value: user.email
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "Account-profile-input"
  }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    disabled: true,
    fullWidth: true,
    label: "Empresa",
    type: "text",
    value: companyName
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "Account-profile-columns",
    "data-fullwidth": true
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "Account-profile-input"
  }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    fullWidth: true,
    label: "Telefone",
    type: "text",
    mask: "(99) 99999-9999",
    onChange: handleChangeUserPhone,
    value: userPhone
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "Account-profile-input"
  }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    fullWidth: true,
    label: "Data de nascimento",
    type: "date",
    onChange: handleChangeUser('birthdate'),
    value: user.birthdate
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "Account-profile-columns",
    "data-fullwidth": true
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "Account-profile-input"
  }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    fullWidth: true,
    label: "Pa\xEDs",
    type: "text",
    onChange: handleChangeUserAddress('country'),
    value: userAddress === null || userAddress === void 0 ? void 0 : userAddress.country
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "Account-profile-input"
  }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    fullWidth: true,
    label: "Estado",
    type: "text",
    onChange: handleChangeUserAddress('state'),
    value: userAddress === null || userAddress === void 0 ? void 0 : userAddress.state
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "Account-profile-columns",
    "data-fullwidth": true
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "Account-profile-input"
  }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    fullWidth: true,
    label: "Cidade",
    type: "text",
    onChange: handleChangeUserAddress('city'),
    value: userAddress === null || userAddress === void 0 ? void 0 : userAddress.city
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "Account-profile-input"
  }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    fullWidth: true,
    label: "Bairro",
    type: "text",
    onChange: handleChangeUserAddress('district'),
    value: userAddress === null || userAddress === void 0 ? void 0 : userAddress.district
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "Account-profile-columns",
    "data-fullwidth": true
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "Account-profile-input"
  }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    fullWidth: true,
    label: "Rua",
    type: "text",
    onChange: handleChangeUserAddress('street'),
    value: userAddress === null || userAddress === void 0 ? void 0 : userAddress.street
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "Account-profile-input"
  }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    fullWidth: true,
    label: "N\xBA",
    type: "number",
    onChange: handleChangeUserAddress('streetNumber'),
    value: userAddress === null || userAddress === void 0 ? void 0 : userAddress.streetNumber
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "Account-profile-columns",
    "data-fullwidth": true
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "Account-profile-input"
  }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    fullWidth: true,
    label: "Complemento",
    type: "text",
    onChange: handleChangeUserAddress('complementary'),
    value: userAddress === null || userAddress === void 0 ? void 0 : userAddress.complementary
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "Account-profile-input"
  }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    fullWidth: true,
    label: "CEP",
    type: "number",
    onChange: handleChangeUserAddress('postalCode'),
    value: userAddress === null || userAddress === void 0 ? void 0 : userAddress.postalCode
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "Account-profile-actions"
  }, /*#__PURE__*/_react["default"].createElement(_SimpleButton["default"], {
    className: "Account-profile-saveChanges",
    onClick: handleSaveUser
  }, "SALVAR ALTERA\xC7\xD5ES"), /*#__PURE__*/_react["default"].createElement(_SimpleButton["default"], {
    className: "Account-profile-resetChanges",
    onClick: handleResetUser
  }, "RESETAR"))), /*#__PURE__*/_react["default"].createElement("section", {
    className: "Account-profile-section"
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: "Account-title"
  }, "Deletar conta"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "Account-profile-rows",
    "data-fullwidth": true
  }, /*#__PURE__*/_react["default"].createElement(_material.FormControlLabel, {
    label: "Confirmo a desativa\xE7\xE3o da minha conta",
    control: /*#__PURE__*/_react["default"].createElement(_material.Checkbox, {
      onChange: function onChange(evt) {
        return setConfirmAccountDeletion(evt.target.checked);
      },
      checked: confirmAccountDeletion
    })
  }), /*#__PURE__*/_react["default"].createElement(_SimpleButton["default"], {
    className: "Account-profile-deleteAccount",
    disabled: !confirmAccountDeletion,
    onClick: handleDisableAccount
  }, "DESATIVAR CONTA"))));
}
var _default = Profile;
exports["default"] = _default;